import { memo } from 'react';

import { type Notification, type NotificationType } from '@air/api/types';
import { NotificationsItem, type NotificationsItemProps } from '@air/component-notifications';

import { NotificationAvatar } from '~/components/AirNotifications/components/NotificationAvatar';
import { formatCreatedAt } from '~/components/AirNotifications/utils/formatCreatedAt';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type NotificationBaseItemProps = Omit<NotificationsItemProps, 'createdAt' | 'isUI2' | 'state'> & {
  notification: Notification<NotificationType, 'account'>;
};

export const NotificationBaseItem = memo(({ notification, ...restOfProps }: NotificationBaseItemProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <NotificationsItem
      createdAt={formatCreatedAt(notification.createdAt)}
      data-id={notification.id}
      prefix={'actor' in notification.data ? <NotificationAvatar actor={notification.data.actor} /> : undefined}
      state={notification.readAt ? 'read' : 'unread'}
      {...restOfProps}
      isUI2={ui2026}
    />
  );
});

NotificationBaseItem.displayName = 'NotificationBaseItem';
